import { Form } from "antd";
import { useEffect, useState } from "react";

export function useFormValue ({
  path,
  value,
  initialValue,
  handleChange
}: {
  path: string;
  value: string | number | undefined;
  initialValue: string | number | undefined;
  handleChange: (path: string, value: any) => void
}) {
  const [mounted, setMounted] = useState(false);
  const form = Form.useFormInstance();

  useEffect(() => {
    if (mounted) {
      if (value !== form.getFieldValue(path)) {
        form.setFieldsValue({ [path]: value });
      }
    } else {
      if (!value && initialValue) {
        form.setFieldsValue({ [path]: initialValue });

        setTimeout(() => {
          handleChange(path, initialValue);
        }, 50);
      }

      setMounted(true);
    }
  }, [value]);

  return value || initialValue;
}
